import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Label,
    Form,
    // Input,
    FormGroup,
    Modal,
    ModalBody,
} from "reactstrap";
import {
    Grid,
    TextField,
    MenuItem,
    InputAdornment,
    IconButton,FormControl,Input,InputLabel,FormControlLabel,Select,ListItemText
} from "@mui/material";
import CustomButton from "../../../components/CustomButton/CustomButton.jsx";
import LoaderButton from "../../../components/CustomButton/LoaderButton";
// import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";
// import ListItemText from "@mui/material/ListItemText";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import Select from "@mui/material/Select";
// import Input from "@mui/material/Input";
import Util from "../../../utils/helper/index";
import { Visibility,VisibilityOff } from "@mui/icons-material";
import { countries } from "../../../utils/countriesDropdown";
import { resetDealerAddUpdateDivisionList, dealerAddUpdateDivisonList } from '../../../redux/actions/dealerAddUpdateDivisionListAction';
import { resetDealerAddUpdateDistrictList, dealerAddUpdateDistrictList } from "../../../redux/actions/dealerAddUpdateDistrictListAction";
import { resetDealerAddUpdateThanaList, dealerAddUpdateThanaList } from '../../../redux/actions/dealerAddUpdateThanaListAction';
import { resetDealerAddUpdateUnionList, dealerAddUpdateUnionList } from '../../../redux/actions/dealerAddUpdateUnionListAction';
import { resetbankRoleList, bankRoleList } from '../../../redux/actions/bankRolelistAction.js';
import { resetaddUpdateUserManagement, addUpdateUserManagement } from "../../../redux/actions/bankUserManagementAddUpdateAction.js";

function AddNewUser({ action }) {

    const [isError, setIsError] = useState(false);
    const pattern = new RegExp(/^\d{1,20}$/);
    const [userName, setuserName] = useState("");
    const [password, setpassword] = useState("");
    const [confirmPassword, setconfirmPassword] = useState("");
    const [role, setrole] = useState("");
    const [fullName, setfullName] = useState("");
    const [email, setemail] = useState("");
    const [phoneNumber, setphoneNumber] = useState("");
    const [address, setaddress] = useState("");
    const [country, setcountry] = useState("Bangladesh");
    const [region, setregion] = useState("");
    const [city, setcity] = useState("");
    const [pincode, setpincode] = useState("");
    const [division, setdivision] = useState("");
    const [district, setdistrict] = useState("");
    const [thana, setthana] = useState("");
    const [union, setunion] = useState("");
    const [showPassword, setshowPassword] = useState(false);
    const [showconfirmPassword, setshowconfirmPassword] = useState(false);

    const dispatch = useDispatch();

    const login = useSelector(({ login }) => login);
    const rolelist = useSelector(({ bankRolelist }) => bankRolelist);
    const useraddupdate = useSelector(({ bankUserManagementAddUpdate }) => bankUserManagementAddUpdate);
    const viewUser = useSelector(({ bankUserManagementview }) => bankUserManagementview);
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    const divisionlist = useSelector(
        ({ dealerAddUpdateDivisionLists }) => dealerAddUpdateDivisionLists
    )
    const districtlist = useSelector(
        ({ dealerAddUpdateDistrictLists }) => dealerAddUpdateDistrictLists
    )
    const thanalist = useSelector(
        ({ dealerAddUpdateThanaLists }) => dealerAddUpdateThanaLists
    )
    const unionlist = useSelector(
        ({ dealerAddUpdateUnionLists }) => dealerAddUpdateUnionLists
    )

    console.log("action", action)

    const handleSubmit = (e) => {
        e.preventDefault();
        const req = {
            actionCustomerMasterRequestVO: {
                ratId: action === "updateUser" ? viewUser.data.viewMgtList.ratId : "",
                name: fullName,
                mobile: phoneNumber,
                email,
                adminId: "",
                role,
                userName,
                country,
                state: country === "Bangladesh" ? division : region,
                city: country === "Bangladesh" ? district : city,
                address,
                postalCode: pincode,
                password,
                bankId: login.data.partnerId,
                //division,
                //district,
                thana,
                union,
                region: "1",
                area: "1",
            }
        }

        if (regenerateTokenRes.success) {
            dispatch(addUpdateUserManagement(req, regenerateTokenRes.data.AuthToken))
        }
    }

    const handleChange = ({ target: { value, name } }) => {

        if (name === "userName") {
            setuserName(value);
        }

        if (name === "password") {
            setpassword(value);
        }

        if (name === "confirmPassword") {
            setconfirmPassword(value);
        }

        if (name === "role") {
            setrole(value);
        }

        if (name === "fullName") {
            setfullName(value);
        }

        if (name === "email") {
            setemail(value);
        }

        if (name === "phoneNumber") {
            setphoneNumber(value);
        }



        if (name === "address") {
            setaddress(value);
        }

        if (name === "country") {
            setcountry(value);
            if (value === "Bangladesh") {
                setregion("");
                setcity("");
                setpincode("");
            }
            else {
                setdivision("");
                setdistrict("");
                setthana("");
                setunion("");
            }
        }

        if (name === "region") {
            setregion(value);
        }

        if (name === "city") {
            setcity(value);
        }

        if (name === "pincode") {
            setpincode(value);
        }

        if (name === "division") {
            setdivision(value);
        }

        if (name === "district") {
            setdistrict(value);
        }

        if (name === "thana") {
            setthana(value);
        }

        if (name === "union") {
            setunion(value);
        }
    }

    const getRoleList = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                bankId: login.data.partnerId,
                adminId: "",
            }
        }

        if (regenerateTokenRes.success) {
            dispatch(bankRoleList(req, regenerateTokenRes.data.AuthToken))
        }
    }

    const getDivisionList = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: login.data.partnerId,
            }
        }

        if (regenerateTokenRes.success) {
            dispatch(dealerAddUpdateDivisonList(req, regenerateTokenRes.data.AuthToken))
        }
    }

    const getDistrictandThanaList = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: login.data.partnerId,
                district: division

            }
        }

        if (regenerateTokenRes.success) {
            dispatch(dealerAddUpdateDistrictList(req, regenerateTokenRes.data.AuthToken))
            dispatch(dealerAddUpdateThanaList(req, regenerateTokenRes.data.AuthToken))
        }
    }

    const getUnionList = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: login.data.partnerId,
                district: division,
                thana: thana
            }
        }

        if (regenerateTokenRes.success) {
            dispatch(dealerAddUpdateUnionList(req, regenerateTokenRes.data.AuthToken))
        }
    }

    const togglePassword = () => {
        setshowPassword(!showPassword);
    }

    const toggleconfirmPassword = () => {
        setshowconfirmPassword(!showconfirmPassword);
    }

    const disabledButton = () => {
        if (action === "addUser") {
            if (country === "Bangladesh") {
                return !(userName && role && password && confirmPassword && (password === confirmPassword) && fullName && email
                    && phoneNumber && address && country && division && district && thana && union);
            }
            else {
                return !(userName && role && password && confirmPassword && (password === confirmPassword) && fullName && email
                    && phoneNumber && address && country && region && city && pincode);
            }
        }
        else {
            if (country === "Bangladesh") {
                return !(fullName && address && country && division && district && thana && union);
            }
            else {
                return !(fullName && address && country && region && city && pincode);
            }
        }
    }

    useEffect(() => {
        getDivisionList();
        getRoleList();
        if (division) {
            getDistrictandThanaList();
        }
        if (division && thana) {
            getUnionList();
        }
    }, [division, thana]);

    useEffect(() => {
        if (viewUser.success) {
            setuserName(viewUser.data.viewMgtList.userName)
            setrole(viewUser.data.viewMgtList.role)
            setfullName(viewUser.data.viewMgtList.name)
            setemail(viewUser.data.viewMgtList.email)
            setphoneNumber(viewUser.data.viewMgtList.phoneNo)
            setaddress(viewUser.data.viewMgtList.address)
            setcountry(viewUser.data.viewMgtList.country)
            setregion(viewUser.data.viewMgtList.region)
            setcity(viewUser.data.viewMgtList.city)
            setpincode(viewUser.data.viewMgtList.postalCode)
            setdivision(viewUser.data.viewMgtList.state)
            setdistrict(viewUser.data.viewMgtList.city)
            setthana(viewUser.data.viewMgtList.thana)
            setunion(viewUser.data.viewMgtList.union)
        }
    }, [viewUser])

    useEffect(() => {
        return () => {
            dispatch(resetDealerAddUpdateDivisionList());
            dispatch(resetDealerAddUpdateDistrictList());
            dispatch(resetDealerAddUpdateThanaList());
            dispatch(resetDealerAddUpdateUnionList());
            dispatch(resetbankRoleList());
            dispatch(resetaddUpdateUserManagement());
        }
    }, [])


    return (
        <Form onSubmit={handleSubmit}>
            <Row style={{
                padding: "0px 25px",
                marginBottom: "25px"
            }}>
                <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                    <TextField
                        required
                        type="text"
                        size="small"
                        color="primary"
                        autoFocus={true}
                        label="Username"
                        fullWidth={true}
                        name="userName"
                        value={userName}
                        onChange={handleChange}
                        disabled={action !== "addUser" ? "disabled" : ""}
                    />
                </Col>
                <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                    <TextField
                        select
                        size="small"
                        color="primary"
                        type="text"
                        label="Role"
                        fullWidth={true}
                        name="role"
                        value={role}
                        onChange={handleChange}
                        disabled={action !== "addUser" ? "disabled" : ""}
                    >
                        <MenuItem value="" selected="Select Role">
                            Select Role
                        </MenuItem>
                        {rolelist.success && rolelist.data.errorList.map((value) => (
                            <MenuItem value={value.$}>
                                {value.$}
                            </MenuItem>
                        ))}
                    </TextField>
                </Col>
                {action === "addUser" && <>
                    <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>

                        <TextField
                            required
                            helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
                            type={showPassword ? "text" : "password"}
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Password"
                            fullWidth={true}
                            name="password"
                            id="password"
                            value={password}
                            onChange={handleChange}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={togglePassword}
                                            onMouseDown={togglePassword}
                                        >
                                            {showPassword ? (
                                                <Visibility />
                                            ) : (
                                                <VisibilityOff />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Col>
                    <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>

                        <TextField
                            required
                            helperText="(Should be same as Password)"
                            type={showconfirmPassword ? "text" : "password"}
                            size="small"
                            color="primary"
                            autoFocus={true}
                            label="Confirm Password"
                            fullWidth={true}
                            name="confirmPassword"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={handleChange}
                            error={
                                password &&
                                    password !== confirmPassword &&
                                    confirmPassword ? (
                                    <p
                                        className="passwordNotMatch"
                                        style={{ color: "red" }}
                                    >
                                        {"Password did not match"}
                                    </p>
                                ) : (
                                    ""
                                )
                            }
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={toggleconfirmPassword}
                                            onMouseDown={toggleconfirmPassword}
                                        >
                                            {showconfirmPassword ? (
                                                <Visibility />
                                            ) : (
                                                <VisibilityOff />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Col>
                </>}
                <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                    <TextField
                        required
                        type="text"
                        size="small"
                        color="primary"
                        autoFocus={true}
                        label="Fullname"
                        fullWidth={true}
                        name="fullName"
                        value={fullName}
                        onChange={handleChange}
                        disabled={action === "viewUser" ? "disabled" : ""}
                    />
                </Col>
                <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                    <TextField
                        required
                        type="text"
                        size="small"
                        color="primary"
                        autoFocus={true}
                        label="Email"
                        fullWidth={true}
                        name="email"
                        value={email}
                        onChange={handleChange}
                        disabled={action !== "addUser" ? "disabled" : ""}
                    />
                </Col>
                <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                    <TextField
                        required
                        // helperText="(Only numbers allow)"

                        // error={isError}
                        type="text"
                        size="small"
                        color="primary"
                        autoFocus={true}
                        label="Enter Phone Number"
                        fullWidth={true}
                        name="phoneNumber"
                        value={phoneNumber}
                        onChange={(e) => {
                            setphoneNumber(e.target.value);
                            if (!pattern.test(e.target.value))
                                setIsError(true);
                            else
                                setIsError(false);
                        }}
                        disabled={action !== "addUser" ? "disabled" : ""}
                    />

                    <p
                        className="phoneInputMsg"
                        style={{ color: phoneNumber === "" ? 'grey' : "red" }}
                    >

                        {isError ? "(Only numbers allow)" : ""}
                    </p>
                </Col>
                <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                    <TextField
                        required
                        type="text"
                        size="small"
                        color="primary"
                        autoFocus={true}
                        label="Address"
                        fullWidth={true}
                        name="address"
                        value={address}
                        onChange={handleChange}
                        disabled={action === "viewUser" ? "disabled" : ""}
                    />
                </Col>
                <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                    <TextField
                        select
                        size="small"
                        color="primary"
                        type="text"
                        label="Country"
                        fullWidth={true}
                        name="country"
                        value={country}
                        disabled
                        //disabled={action === "viewUser" ? "disabled" : ""}
                        onChange={handleChange}
                    >
                        <MenuItem value="" selected="Select Country">
                            Select Country
                        </MenuItem>
                        {countries.map((value) => (
                            <MenuItem value={value.label}>
                                {value.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Col>

                {country === "Bangladesh" ?
                    <>
                        <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Division"
                                fullWidth={true}
                                name="division"
                                disabled={action === "viewUser" ? "disabled" : ""}
                                value={division}
                                onChange={handleChange}
                            >
                                <MenuItem value="" selected="Select Division">
                                    Select Division
                                </MenuItem>
                                {divisionlist.success && divisionlist.data.list.map((value) => (
                                    <MenuItem value={value.name}>
                                        {value.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Col>
                        <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="District"
                                fullWidth={true}
                                name="district"
                                value={district}
                                disabled={action === "viewUser" ? "disabled" : ""}
                                onChange={handleChange}
                            >
                                <MenuItem value="" selected="Select District">
                                    Select District
                                </MenuItem>
                                {districtlist.success && districtlist.data.list.map((value) => (
                                    <MenuItem value={value.name}>
                                        {value.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Col>
                        <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Thana/Upazilla"
                                fullWidth={true}
                                name="thana"
                                value={thana}
                                disabled={action === "viewUser" ? "disabled" : ""}
                                onChange={handleChange}
                            >
                                <MenuItem value="" selected="Select Thana/Upazilla">
                                    Select Thana/Upazilla
                                </MenuItem>
                                {thanalist.success && thanalist.data.list.map((value) => (
                                    <MenuItem value={value.name}>
                                        {value.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Col>
                        <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Union/Ward"
                                fullWidth={true}
                                name="union"
                                value={union}
                                disabled={action === "viewUser" ? "disabled" : ""}
                                onChange={handleChange}
                            >
                                <MenuItem value="" selected="Select Union/Ward">
                                    Select Union/Ward
                                </MenuItem>
                                {unionlist.success && unionlist.data.list.map((value) => (
                                    <MenuItem value={value.name}>
                                        {value.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Col>
                    </>
                    :
                    <>
                        <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>

                            <TextField
                                required
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Region"
                                fullWidth={true}
                                name="region"
                                value={region}
                                disabled={action === "viewUser" ? "disabled" : ""}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>

                            <TextField
                                required
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="City"
                                fullWidth={true}
                                name="city"
                                value={city}
                                disabled={action === "viewUser" ? "disabled" : ""}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>

                            <TextField
                                required
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Pincode"
                                fullWidth={true}
                                name="pincode"
                                value={pincode}
                                disabled={action === "viewUser" ? "disabled" : ""}
                                onChange={handleChange}
                            />
                        </Col>
                    </>}
            </Row>
            {action !== "viewUser" &&
                <Row style={{
                    marginBottom: "5px"
                }}>
                    <Col md={12} className="d-flex justify-content-center">
                        <CustomButton
                            color="primary"
                            className="buttons"
                            round
                            disabled={disabledButton() || useraddupdate.isLoading}
                            type="submit"
                        >
                            <LoaderButton
                                isLoading={useraddupdate.isLoading}
                                spinner={useraddupdate.isLoading}
                            >
                                Save
                            </LoaderButton>
                        </CustomButton>
                    </Col>
                </Row>}
        </Form>
    )
}

export default AddNewUser